import { get, post } from "@/utils/request"
import { debounce } from "lodash-es"

// 获取锁接口
export const getDocLock = (params,config={}) => get<any>('/cmp-doc/operator-lock/lock', params,config)
// 防抖后的方法，300ms 内多次调用只执行一次
// export const getDocLock = debounce(_getDocLock, 300)
// 释放锁接口
export const releaseDocLock = (params) => get<any>('/cmp-doc/operator-lock/lock/release', params)
// export const releaseDocPostLock = (params) => post<any>('/cmp-doc/operator-lock/lock/release', params)
